import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const SkipOptionEmptyState = {
  skipOptions: [],
  selectedHeaderSkipOption: null,
  selectedFooterSkipOption: null,
};

export const SkipOptionKey = 'skipOptions';

export const skipOptionsSlice = createSlice({
  name: 'skipOptions',
  initialState: getLocalStorage(LocalStorageTypes.SKIPOPTIONS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.SKIPOPTIONS))
    : SkipOptionEmptyState,
  reducers: {
    setSkipOptions: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.SKIPOPTIONS, result);
      return result;
    },
    updateSelectedSkipOption: (state, action) => {
      const { key, value } = action.payload;

      const result = {
        ...state,
        [key]: value,
      };
      persistLocalStorage(SkipOptionKey, result);
      return result;
    },
    resetSkipOptions: () => {
      clearLocalStorage(SkipOptionKey);
      return SkipOptionEmptyState;
    },
  },
});

export const { setSkipOptions, updateSelectedSkipOption, resetSkipOptions } =
  skipOptionsSlice.actions;

export default skipOptionsSlice.reducer;
